import React, { useState, useEffect } from 'react';
import './AI-health-informatics-csr-health-services.css';

function AIHealthInformaticsCsrHealthServices() {
  const [activeTab, setActiveTab] = useState('overview');
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setActiveTab(sectionId);
      setMobileMenuOpen(false);
    }
  };

  return (
    <div className="ai-csr-master-container">
      {/* Hero Section */}
     <section className="ai-csr-hero-section">

  {/* BACKGROUND IMAGE */}
  <img
    src="/data-science-banner.jpeg"
    alt="Data Science Banner"
    className="ai-csr-hero-bg"
  />

  <div className="ai-csr-hero-overlay"></div>

  <div className="ai-csr-hero-content">

    <h1 className="ai-csr-hero-title">
      AI Health Informatics &<br />
      CSR Health Services Project Management Division
    </h1>

    <div className="ai-csr-hero-quote">
      <p>Advising the Intelligence Behind Healthcare Systems.</p>
      <p className="ai-csr-hero-quote-highlight">
        Structuring Impact Beyond Intervention.
      </p>
    </div>

    <button
      className="ai-csr-hero-cta"
      onClick={() => scrollToSection('strategic-intro')}
    >
      Explore Our Strategic Approach
    </button>

  </div>

  <div className="ai-csr-hero-scroll-indicator">
    <span></span>
  </div>

</section>

     

      {/* Strategic Introduction Section */}
      <section id="strategic-intro" className="ai-csr-section ai-csr-section-light">
        <div className="ai-csr-container">
          <div className="ai-csr-section-header">
            <span className="ai-csr-section-tag">Strategic Introduction</span>
            <h2 className="ai-csr-section-title">The Healthcare Transformation Challenge</h2>
            <div className="ai-csr-title-underline"></div>
          </div>

          <div className="ai-csr-intro-grid">
            <div className="ai-csr-intro-card">
              <div className="ai-csr-intro-icon"></div>
              <h3>Data-Centric Healthcare</h3>
              <p>Moving beyond reactive treatment to intelligent, data-driven delivery systems</p>
            </div>
            <div className="ai-csr-intro-card">
              <div className="ai-csr-intro-icon"></div>
              <h3>AI & Predictive Analytics</h3>
              <p>Leveraging artificial intelligence for proactive health management</p>
            </div>
            <div className="ai-csr-intro-card">
              <div className="ai-csr-intro-icon"></div>
              <h3>Digital Health Ecosystems</h3>
              <p>Creating seamlessly integrated healthcare networks</p>
            </div>
            <div className="ai-csr-intro-card">
              <div className="ai-csr-intro-icon"></div>
              <h3>Measurable Outcomes</h3>
              <p>Accountability through quantifiable health metrics</p>
            </div>
          </div>

          <div className="ai-csr-problem-statement">
            <div className="ai-csr-problem-icon">⚠️</div>
            <h3>The Critical Gap</h3>
            <p>Healthcare systems are becoming technologically complex—but strategically misaligned.</p>
            <div className="ai-csr-problem-list">
              <div className="ai-csr-problem-item">Lack of strategic planning</div>
              <div className="ai-csr-problem-item">Poor integration with clinical workflows</div>
              <div className="ai-csr-problem-item">Absence of ethical and legal oversight</div>
              <div className="ai-csr-problem-item">Misinterpretation of health data</div>
              <div className="ai-csr-problem-item">Superficial CSR program design</div>
            </div>
          </div>

          <div className="ai-csr-role-box">
            <h3>Our Role in This Landscape</h3>
            <p className="ai-csr-role-statement">High-Level Strategic Advisory Authority in Healthcare Intelligence, AI Governance, and CSR Health Impact Design</p>
            <div className="ai-csr-role-divider"></div>
            <div className="ai-csr-non-services">
              <span>✖ Not a software company</span>
              <span>✖ Not an IT service provider</span>
              <span>✖ Not a hospital operations unit</span>
              <span>✖ Not a field implementation agency</span>
            </div>
          </div>
        </div>
      </section>


{/* MID BANNER */}
<section className="mlme-mid-banner-ai">

  <img
    src="/data-science-mid-first-banner.jpeg"
    alt="Medico Legal Banner"
    className="mlme-mid-banner-ai-img"
  />
</section>



      {/* Foundational Philosophy Section */}
      <section className="ai-csr-section ai-csr-section-dark">
        <div className="ai-csr-container">
          <div className="ai-csr-section-header">
            <span className="ai-csr-section-tag ai-csr-section-tag-light">Foundational Philosophy</span>
            <h2 className="ai-csr-section-title ai-csr-title-light">Four Pillars of Our Advisory Model</h2>
            <div className="ai-csr-title-underline ai-csr-underline-light"></div>
          </div>

          <div className="ai-csr-philosophy-grid">
            <div className="ai-csr-philosophy-card">
              <div className="ai-csr-philosophy-number">01</div>
              <h3>Intelligence Over Infrastructure</h3>
              <p>Modern healthcare doesn't fail due to lack of technology—it fails due to lack of intelligent planning and interpretation.</p>
              <blockquote>"A poorly planned AI system is more dangerous than no system at all."</blockquote>
            </div>
            <div className="ai-csr-philosophy-card">
              <div className="ai-csr-philosophy-number">02</div>
              <h3>Ethics Before Innovation</h3>
              <p>Innovation without ethical governance leads to patient harm, legal liability, and institutional reputational damage.</p>
              <blockquote>Ethical frameworks guide every strategic recommendation</blockquote>
            </div>
            <div className="ai-csr-philosophy-card">
              <div className="ai-csr-philosophy-number">03</div>
              <h3>Advisory Independence</h3>
              <p>Vendor-neutral, independent advisory ensuring unbiased, client-focused recommendations without implementation conflicts.</p>
              <blockquote>No technology selling. No implementation bias.</blockquote>
            </div>
            <div className="ai-csr-philosophy-card">
              <div className="ai-csr-philosophy-number">04</div>
              <h3>Impact-Oriented CSR</h3>
              <p>Redefining CSR as Structured Health Impact Investment with Measurable Outcomes—not symbolic activities.</p>
              <blockquote>Impact defined before funds are spent</blockquote>
            </div>
          </div>
        </div>
      </section>

      {/* AI Health Informatics Advisory Section */}
      <section id="ai-advisory" className="ai-csr-section ai-csr-section-light">
        <div className="ai-csr-container">
          <div className="ai-csr-section-header">
            <span className="ai-csr-section-tag">AI Health Informatics Advisory</span>
            <h2 className="ai-csr-section-title">Defining How Intelligent Healthcare Systems Should Think</h2>
            <div className="ai-csr-title-underline"></div>
          </div>

          <div className="ai-csr-advisory-grid">
            <div className="ai-csr-advisory-card">
              <div className="ai-csr-advisory-icon"></div>
              <h3>Strategic AI Adoption</h3>
              <p>Guiding organizations on where AI creates real value, which processes remain human-driven, and long-term implications of AI adoption.</p>
              <div className="ai-csr-advisory-focus">
                <strong>Focus:</strong> Clinical priorities, operational efficiency, patient safety
              </div>
            </div>

            <div className="ai-csr-advisory-card">
              <div className="ai-csr-advisory-icon"></div>
              <h3>Health Data Interpretation</h3>
              <p>Structured frameworks helping leadership understand patterns in patient outcomes, disease trends, and operational inefficiencies.</p>
              <div className="ai-csr-advisory-focus">
                <strong>Note:</strong> Strategic interpreters—not data processors
              </div>
            </div>

            <div className="ai-csr-advisory-card">
              <div className="ai-csr-advisory-icon"></div>
              <h3>Clinical Decision Support</h3>
              <p>Evaluating reliability, clinical applicability, and ethical boundaries of AI-supported decision systems.</p>
              <div className="ai-csr-advisory-focus">
                <strong>Principle:</strong> AI must assist clinicians—not replace them
              </div>
            </div>

            <div className="ai-csr-advisory-card">
              <div className="ai-csr-advisory-icon"></div>
              <h3>System Design Thinking</h3>
              <p>Conceptual system architecture focusing on information flow, decision-making processes, and safe AI integration.</p>
              <div className="ai-csr-advisory-focus">
                <strong>Defining:</strong> What systems should achieve and how they should function
              </div>
            </div>








            <div className="ai-csr-advisory-card ai-csr-advisory-full">
              <div className="ai-csr-advisory-icon"></div>
              <h3>AI Risk & Governance Advisory</h3>
              <div className="ai-csr-risk-grid">
                <div className="ai-csr-risk-type">
                  <h4>Clinical Risk</h4>
                  <p>Misinterpretation of AI outputs, over-reliance on automated recommendations</p>
                </div>
                <div className="ai-csr-risk-type">
                  <h4>Legal Risk</h4>
                  <p>Liability in AI-assisted decisions, data breaches and misuse</p>
                </div>
                <div className="ai-csr-risk-type">
                  <h4>Ethical Risk</h4>
                  <p>Bias against populations, lack of transparency in decisions</p>
                </div>
              </div>
            </div>

            <div className="ai-csr-advisory-card ai-csr-advisory-full">
              <div className="ai-csr-advisory-icon"></div>
              <h3>Digital Health Transformation</h3>
              <p>Strategic guidance through organizational change—not just technology implementation.</p>
              <div className="ai-csr-transformation-list">
                <span>Strategic planning</span>
                <span>Role redefinition</span>
                <span>Workflow restructuring</span>
                <span>Change management</span>
              </div>
            </div>
          </div>
        </div>
      </section>






{/* MID BANNER */}
<section className="mlme-mid-banner-ai-second">

  <img
    src="/data-science-mid-banner.jpeg"
    alt="Medico Legal Banner"
    className="mlme-mid-banner-ai-second-img"
  />
</section>


      {/* CSR Health Services Advisory Section */}
      <section id="csr-advisory" className="ai-csr-section ai-csr-section-gradient">
        <div className="ai-csr-container">
          <div className="ai-csr-section-header">
            <span className="ai-csr-section-tag ai-csr-section-tag-light">CSR Health Services Advisory</span>
            <h2 className="ai-csr-section-title ai-csr-title-light">Designing Healthcare Impact Systems—Not Just Programs</h2>
            <div className="ai-csr-title-underline ai-csr-underline-light"></div>
          </div>

          <div className="ai-csr-csr-grid">
            <div className="ai-csr-csr-card">
              <div className="ai-csr-csr-icon"></div>
              <h3>CSR Health Strategy</h3>
              <p>Designing long-term, evidence-based strategies aligned with public health needs and measurable outcomes.</p>
              <div className="ai-csr-csr-feature">▶ Structured Health Impact Investment</div>
            </div>

            <div className="ai-csr-csr-card">
              <div className="ai-csr-csr-icon"></div>
              <h3>Community Health Intelligence</h3>
              <p>Analyzing disease patterns, socioeconomic determinants, and healthcare access to ensure programs address real problems.</p>
              <div className="ai-csr-csr-feature">▶ Evidence-Based Targeting</div>
            </div>

            <div className="ai-csr-csr-card">
              <div className="ai-csr-csr-icon"></div>
              <h3>Program Design Architecture</h3>
              <p>Developing structured programs with clear objectives, defined populations, measurable indicators, and scalable models.</p>
              <div className="ai-csr-csr-feature">▶ Scalable & Sustainable</div>
            </div>

            <div className="ai-csr-csr-card">
              <div className="ai-csr-csr-icon"></div>
              <h3>Implementation Framework</h3>
              <p>Defining how projects should be implemented, who should be involved, what resources are required, and risk controls.</p>
              <div className="ai-csr-csr-feature">▶ Strategic Blueprint Design</div>
            </div>

            <div className="ai-csr-csr-card">
              <div className="ai-csr-csr-icon"></div>
              <h3>Impact Measurement Systems</h3>
              <p>Designing systems to evaluate health outcomes, behavioral changes, program efficiency, and long-term sustainability.</p>
              <div className="ai-csr-csr-feature">▶ Data-Driven Evaluation</div>
            </div>

            <div className="ai-csr-csr-card">
              <div className="ai-csr-csr-icon"></div>
              <h3>Ethical & Legal Safeguards</h3>
              <p>Ensuring full compliance, ethical integrity, and legal defensibility in healthcare CSR projects.</p>
              <div className="ai-csr-csr-feature">▶ Risk-Protected Programs</div>
            </div>
          </div>
        </div>
      </section>

      {/* Integrated Intelligence Model */}
      <section id="integrated-model" className="ai-csr-section ai-csr-section-light">
        <div className="ai-csr-container">
          <div className="ai-csr-integrated-header">
            <span className="ai-csr-integrated-badge">Integrated Intelligence Model</span>
            <h2 className="ai-csr-integrated-title">AI + CSR = Strategic Health Impact</h2>
            <p className="ai-csr-integrated-subtitle">Combining AI insights, health data interpretation, and CSR strategy to design predictive, preventive, and sustainable programs</p>
          </div>

          <div className="ai-csr-integrated-grid">
            <div className="ai-csr-integrated-card">
              <div className="ai-csr-integrated-icon"></div>
              <h3>AI Insights</h3>
              <p>Predictive analytics and pattern recognition for informed decision-making</p>
            </div>
            <div className="ai-csr-integrated-plus">+</div>
            <div className="ai-csr-integrated-card">
              <div className="ai-csr-integrated-icon"></div>
              <h3>Health Data Interpretation</h3>
              <p>Strategic frameworks turning data into actionable intelligence</p>
            </div>
            <div className="ai-csr-integrated-plus">=</div>
            <div className="ai-csr-integrated-card ai-csr-integrated-highlight">
              <div className="ai-csr-integrated-icon"></div>
              <h3>Strategic Health Impact</h3>
              <p>Predictive • Preventive • Sustainable • Measurable</p>
            </div>
          </div>

          <div className="ai-csr-example-box">
            <div className="ai-csr-example-badge">Example</div>
            <div className="ai-csr-example-content">
              <div className="ai-csr-example-traditional">
                <h4>Traditional Approach</h4>
                <p>Conducting a one-day health camp</p>
              </div>
              <div className="ai-csr-example-arrow">→</div>
              <div className="ai-csr-example-advanced">
                <h4>Our Approach</h4>
                <p>Risk-based population targeting + Long-term monitoring + Outcome evaluation systems</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Who We Serve */}
      <section className="ai-csr-section ai-csr-section-dark">
        <div className="ai-csr-container">
          <div className="ai-csr-section-header">
            <span className="ai-csr-section-tag ai-csr-section-tag-light">Who We Serve</span>
            <h2 className="ai-csr-section-title ai-csr-title-light">Trusted By Industry Leaders</h2>
            <div className="ai-csr-title-underline ai-csr-underline-light"></div>
          </div>

          <div className="ai-csr-clients-grid">
            <div className="ai-csr-client-card">
              <div className="ai-csr-client-icon"></div>
              <h3>Corporate Organizations</h3>
              <p>CSR strategy and health program design</p>
            </div>
            <div className="ai-csr-client-card">
              <div className="ai-csr-client-icon"></div>
              <h3>Healthcare Institutions</h3>
              <p>AI advisory and digital transformation</p>
            </div>
            <div className="ai-csr-client-card">
              <div className="ai-csr-client-icon"></div>
              <h3>NGOs & International Bodies</h3>
              <p>Program architecture and impact frameworks</p>
            </div>
            <div className="ai-csr-client-card">
              <div className="ai-csr-client-icon"></div>
              <h3>Government Initiatives</h3>
              <p>Strategic advisory for public health</p>
            </div>
            <div className="ai-csr-client-card">
              <div className="ai-csr-client-icon"></div>
              <h3>Health-Tech Investors</h3>
              <p>Due diligence and governance guidance</p>
            </div>
          </div>
        </div>
      </section>

      {/* Value Proposition Section */}
      <section id="value-proposition" className="ai-csr-section ai-csr-section-light">
        <div className="ai-csr-container">
          <div className="ai-csr-section-header">
            <span className="ai-csr-section-tag">Value Proposition</span>
            <h2 className="ai-csr-section-title">Distinctive Advantages</h2>
            <div className="ai-csr-title-underline"></div>
          </div>

          <div className="ai-csr-value-grid">
            <div className="ai-csr-value-card">
              <div className="ai-csr-value-number">01</div>
              <h3>Multidisciplinary Intelligence</h3>
              <p>Medicine + Law + Management + Engineering + Ethics</p>
            </div>
            <div className="ai-csr-value-card">
              <div className="ai-csr-value-number">02</div>
              <h3>Pure Advisory Model</h3>
              <p>No operational distraction—only high-level thinking</p>
            </div>
            <div className="ai-csr-value-card">
              <div className="ai-csr-value-number">03</div>
              <h3>Ethical Leadership</h3>
              <p>Rare expertise in medical law and AI ethics</p>
            </div>
            <div className="ai-csr-value-card">
              <div className="ai-csr-value-number">04</div>
              <h3>Strategic Depth</h3>
              <p>Doctoral-level analytical approach</p>
            </div>
          </div>

          <div className="ai-csr-scope-declaration">
            <h3>Professional Scope Declaration</h3>
            <div className="ai-csr-scope-content">
              <div className="ai-csr-scope-item">
                <span className="ai-csr-scope-icon">⚠️</span>
                <p>No technical development services are provided</p>
              </div>
              <div className="ai-csr-scope-item">
                <span className="ai-csr-scope-icon">⚠️</span>
                <p>No clinical or medical treatment is delivered</p>
              </div>
              <div className="ai-csr-scope-item">
                <span className="ai-csr-scope-icon">⚠️</span>
                <p>No direct project execution is undertaken</p>
              </div>
              {/* <div className="ai-csr-scope-item">
                <span className="ai-csr-scope-icon">✓</span>
                <p>All services are strategic, analytical, and advisory in nature</p>
              </div> */}
            </div>
          </div>
        </div>
      </section>

      {/* Final Strategic Statement */}
      <section className="ai-csr-final-statement">
        <div className="ai-csr-container">
          <div className="ai-csr-final-content">
            <div className="ai-csr-final-quote">"</div>
            <div className="ai-csr-final-grid">
              <div className="ai-csr-final-item">
                <p>We do not build healthcare systems.</p>
                <span>We define how they should be built, governed, and evaluated.</span>
              </div>
              <div className="ai-csr-final-item">
                <p>We do not run CSR programs.</p>
                <span>We design how they should create real, measurable health impact.</span>
              </div>
            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default AIHealthInformaticsCsrHealthServices;